import t from"react";import{MdIcon as o}from"./MdIcon.js";import{mdiUnfoldLessHorizontal as e}from"@mdi/js";const r=({id:r="collapse",title:i="Collapse",...m})=>t.createElement(o,{id:r,title:i,path:e,...m});export{r as CollapseIcon};
